<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.marka_veri_girisleri"  url="NewBrandReport" :show_button="false" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">

<div class="grid mt-5">


<div class="col-6 md:col-3 mt-4">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_project_id" :options="projects" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" @change="getFlows" >

<template #value="slotProps">
  <template v-if="slotProps.value">
    {{selectedProjectName}}
  </template>
  <template v-else>
    <div style="height:18px"></div>
  </template>
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>


</Dropdown>
<label  class="text-primary">{{$store.state.languages.lang_phrases.lutfen_bir_proje_secin}}</label>
</span>
</div>

<div class="col-6 md:col-3 mt-4" v-if="selected_project_id">
<span class="p-float-label">

<Dropdown :filter="true"  v-model="selected_flow_id" :options="projectflows" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm" :loading="loading_flows"  @change="getInputfields">
<template #value="slotProps">
  <template v-if="slotProps.value">
    {{selectedFlowName}}
  </template>
  <template v-else>
    <div style="height:18px"></div>
  </template>
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>

</Dropdown>
<label  class="text-primary">{{$store.state.languages.lang_phrases.lutfen_bir_asama_secin}}</label>
</span>
</div>


<div class="col-6 md:col-3 mt-4" v-if="selected_flow_id">
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_period_id" :options="projectperiods" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm"   @change="getInputfields" />
<label  class="text-primary">{{$store.state.languages.lang_phrases.lutfen_bir_periyod_secin}}</label>
</span>
</div>


<div class="col-6 md:col-3 mt-4" v-if="selected_period_id">
<template v-if="!querable_flow_selected">
<small class="text-red-500 font-bold my-1 mt-3">{{$store.state.languages.lang_phrases.bu_asama_turu_icin_grafik_bulunmuyor}}</small>
</template>
<template v-else>
<span class="p-float-label">
<Dropdown :filter="true"  v-model="selected_inputfield_id" :options="inputfields" optionLabel="short_name" optionValue="id" class="w-full p-inputtext-sm" :loading="loading_inputfield" @change="inputfieldSelected" >
<template #value="slotProps">
  <template v-if="slotProps.value">
    {{selectedInputfieldName}}
  </template>
  <template v-else>
    <div style="height:18px"></div>
  </template>
</template>

<template #option="slotProps">
{{ getTheTranslation(slotProps.option,"translation") }}
</template>

</Dropdown> 
<label  class="text-primary">{{$store.state.languages.lang_phrases.lutfen_bir_soru_secin}}</label>
</span>	
</template>
</div>





<div class="col-12" style="min-height: 300px;" v-if="querable_flow_selected && selected_inputfield_id">
<template v-if="!graph_ready">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="graph_ready">

<!--select type-->  
<template v-if="selected_inputfield.type=='text' || selected_inputfield.type=='longtext'|| selected_inputfield.type=='listinput'">
<div class="grid">
<div class="col-12"><h3 class="text-purple-500">Bu soru tipine göre bir grafik bulunmuyor</h3></div>
</div>
</template>
<!--select type-->


<!--select type-->	
<template v-if="selected_inputfield.type=='select'">
<BarChart :inputfield="selected_inputfield" ref="barchart"></BarChart>
</template>
<!--select type-->	

<!--select type-->	
<template v-if="selected_inputfield.type=='multiselect' || selected_inputfield.type=='listselect'">
<BarChart :inputfield="selected_inputfield" ref="barchart"></BarChart>
</template>
<!--select type-->	

<!--select type-->  
<template v-if="selected_inputfield.type=='number'">
<LineChart 
:inputfield="selected_inputfield" 
ref="linechart" 
></LineChart>
</template>
<!--select type-->

<!--select type-->  
<template v-if="selected_inputfield.type=='columns'">
<LineChart :inputfield="selected_inputfield" :selectedreadonlycolumns="selectedreadonlycolumns" ref="linechart"  :subdatalenght="subdatalenght"></LineChart>
</template>
<!--select type-->

<!--select type-->	
<template v-if="selected_inputfield.type=='boolean'">
<PieChart :inputfield="selected_inputfield" ref="piechart"></PieChart>
</template>
<!--select type-->




<DataTable 
:value="supplier_data" 
responsiveLayout="scroll"
paginator :rows="20" 
>

<template #header>
<div class="grid">
<div class="col-12">
  <div class="flex align-items-end justify-content-end mb-6">
    <Button :label="$store.state.languages.lang_phrases.excel_rapor_indir" icon="pi pi-cloud-download" class="p-button-outlined p-button-sm" @click="downloadReport"/>
  </div>
</div>
</div>
</template>

  <Column field="suppliers.name" :header="$store.state.languages.lang_phrases.isim" sortable>
     <template #body="{data}">
        <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.suppliers.id}}">{{data.suppliers.name}}</router-link>
      </template>
  </Column>
  <Column field="suppliers.suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu" sortable></Column>


  
<template v-if="selected_inputfield && selected_inputfield.type=='listinput'">
  <template v-for="column in selected_inputfield.sorted_columns">
      <Column  :header="column.name">
        <template #body="{data}">
          <p v-html="getCellListInputValue(data,column.id)" @click="herewego(data,column)"></p>
        </template>
      </Column>
  </template>
</template>

<template v-if="selected_inputfield && selected_inputfield.type=='columns'">
  <template v-for="column in selected_inputfield.sorted_columns">
      <Column  :header="getTheTranslation(column,'translation')">
        <template #body="{data}">
          <p v-html="$filters.numberformatShort( getCellColumnValue(data.id,column.id))"></p>
        </template>
      </Column>
  </template>
</template>


<template v-if="selected_inputfield && selected_inputfield.type=='text'">
  <template v-for="column in selected_inputfield.sorted_columns">
      <Column  :header="getTheTranslation(column,'translation')">
        <template #body="{data}">
          <p v-html="getCellColumnValue(data.id,column.id)"></p>
        </template>
      </Column>
  </template>
</template>

<template v-if="selected_inputfield && selected_inputfield.type=='number'">
  <template v-for="column in selected_inputfield.tablecolumns">
      <Column  :header="getTheTranslation(column,'translation')">
        <template #body="{data}">
          <p v-html="$filters.numberformatShort( getCellColumnValue(data.id,column.id))"></p>
        </template>
      </Column>
  </template>
</template>


<template v-if="selected_inputfield && selected_inputfield.type=='longtext'">
  <template v-for="column in selected_inputfield.sorted_columns">
      <Column  :header="getTheTranslation(column,'translation')">
        <template #body="{data}">
          <p v-html="getCellColumnValue(data.id,column.id)"></p>
        </template>
      </Column>
  </template>
</template>



<template v-if="selected_inputfield && selected_inputfield.type=='listselect'">
  <template v-for="option in selected_inputfield.sorted_options">
      <Column  :header="getTheTranslation(option,'translation')">
        <template #body="{data}">
          <p >{{data.theoption}}</p>
        </template>
      </Column>
  </template>
</template>

<template v-if="selected_inputfield && selected_inputfield.type=='select'">
  <template v-for="option in selected_inputfield.options">
      <Column  :header="getTheTranslation(option,'translation')">
        <template #body="{data}">
          <p v-html="getCellOptionValue(data.id,option.id)"></p>
        </template>
      </Column>
  </template>
</template>

<template v-if="selected_inputfield && selected_inputfield.type=='multiselect'">
  <template v-for="option in selected_inputfield.options">
      <Column  :header="getTheTranslation(option,'translation')">
        <template #body="{data}">
          <p v-html="getCellOptionValue(data.id,option.id)"></p>
        </template>
      </Column>
  </template>
</template>
  
  
</DataTable>






	
</template>

</div>

<div class="col-12" style="min-height: 300px;" v-else>

</div>
</div>

</template>


</div>		
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {

  name: 'BrandInputSubmissionCharts',

  data () {
    return {
    	projects:[],
    	projectflows:[],
      projectperiods:[],
    	inputfields:[],
    	submissiondata:null,
    	selected_project_id:null,
      selected_period_id:null,
    	selected_flow_id:null,
    	selected_project:null,
    	selected_flow:null,
    	selected_section_id:null,
    	selected_section:null,
    	selected_inputfield_id:null,
    	selected_inputfield:null,
    	loading:true,
    	loading_flows:false,
    	loading_inputfield:false,
    	querable_flow_selected:true,
    	graph_ready:false,
      suppliers_table:[],
      supplier_data:null,
      suppliers_columns:[],
      selectedreadonlycolumns:[],
      suppliers_table_columns:[]
    }
  },
  mounted()
  {
    this.getData()
  },
  computed:
  {

    selectedProjectName()
    {
      if(this.selected_project_id)
      {
        let project = this.projects.find(item=>item.id == this.selected_project_id)
        if(project)
        {
          return this.getTheTranslation(project,"translation")
        }
      }
      return ""      
    },

    selectedFlowName()
    {
      if(this.selected_flow_id)
      {
        let flow = this.projectflows.find(item=>item.id == this.selected_flow_id)
        if(flow)
        {
          return this.getTheTranslation(flow,"translation")
        }
      }
      return ""      
    },

    selectedInputfieldName()
    {
      if(this.selected_inputfield_id)
      {
        let inputfield = this.inputfields.find(item=>item.id == this.selected_inputfield_id)
        if(inputfield)
        {
          return this.getTheTranslation(inputfield,"translation")
        }
      }
      return ""      
    },
    subdatalenght()
    {
      return this.supplier_data.length
    },
    preflang()
    {
      return this.$store.state.auth.user.preflang_id
    }
  },
  watch:
  {
    preflang(newval)
    {
      this.inputfieldSelected()
    }
  },
  methods:{
    async downloadReport()
    {
      
      let selected_project = this.projects.find((item)=>{return item.id == this.selected_project_id})
      let selected_period = this.projectperiods.find((item)=>{return item.id == this.selected_period_id})
      
      


      let sheet = []

      let project_name = selected_project.name
      if(selected_project.translations.length)
      {
        let project_translation = selected_project.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(project_translation)
        {
          project_name = project_translation.translation
        }
        else
        {
          project_name = selected_project.name
        }
      }


      sheet.push([
        this.$store.state.languages.lang_phrases.proje+":",
        project_name,
        ])

      let flow_name = this.selected_flow.name
      if(this.selected_flow.translations.length)
      {
        let flow_translation = this.selected_flow.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(flow_translation)
        {
          flow_name = flow_translation.translation
        }
        else
        {
          flow_name = this.selected_flow.name
        }
      }

      sheet.push([
        this.$store.state.languages.lang_phrases.akis+":",
        flow_name,
        ])


      let period_name = selected_period.name

      sheet.push([
        this.$store.state.languages.lang_phrases.proje_periyodu+":",
        period_name,
        ])

      




      let question = this.selected_inputfield.name

      if(this.selected_inputfield.translations.length)
      {
        let inputfield_translation = this.selected_inputfield.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
        if(inputfield_translation)
        {
          question = inputfield_translation.translation
        }
        else
        {
          question = this.selected_inputfield.name
        }
      }

      let question_row = [
        this.$store.state.languages.lang_phrases.soru+":",
        question,
      ]

      sheet.push(question_row)
      sheet.push([" "])



      let row =  [
      "Tedarikçi İsmi",
      "Tedarikçi Kodu(Markaya Özel)",
      ]
      if(this.selected_inputfield.type=="number")
      {
        for(let column of this.selected_inputfield.tablecolumns)
        {
          row.push(column.name)
        }
      }

      if(this.selected_inputfield.type=="text" || this.selected_inputfield.type=="longtext")
      {
        for(let column of this.selected_inputfield.sorted_columns)
        {
          row.push(column.name)
        }
      }

      if(this.selected_inputfield.type=="listinput" )
      {
        for(let column of this.selected_inputfield.sorted_columns)
        {
          row.push(column.name)
        }
      }

      if(this.selected_inputfield.type=="listselect")
      {

          row.push(this.selected_inputfield.name)
      }

      if(this.selected_inputfield.type=="columns")
      {
        for(let column of this.selected_inputfield.sorted_columns)
        {
          row.push(column.name)
        }
      }

      if(this.selected_inputfield.type=="select" || this.selected_inputfield.type=="multiselect")
      {
        for(let option of this.selected_inputfield.options)
        {
          row.push(option.name)
        }
      }

      sheet.push(row)

      for(let sub of this.supplier_data)
      {
        
        let new_row = []
        new_row.push(sub.suppliers.name)
        new_row.push(sub.suppliers.suppliercode)
        //columns
        if(this.selected_inputfield.type=="text" || this.selected_inputfield.type=="longtext")
        {
          for(let column of sub.thecolumns)
          {
            new_row.push(column.value)
          }
        }
        if(this.selected_inputfield.type=="number")
        {
          
          for(let column of sub.thecolumns)
          {
            new_row.push(column.value)
          }
        }


        if(this.selected_inputfield.type=="columns")
        {
          for(let column of sub.thecolumns)
          {
            new_row.push(column.value)
          }
        }

        if(this.selected_inputfield.type=="listinput")
        {
          //console.log(this.selected_inputfield)
          //console.log(sub)
          for(let column of this.selected_inputfield.sorted_columns)
          {
            new_row.push(this.getCellListInputValue(sub,column.id))
          }
        }
        //columns

        if(this.selected_inputfield.type=="listselect")
        {         
          new_row.push(sub.theoption)
        }



        //select
        if(this.selected_inputfield.type=="select" )
        {
          for(let option of this.selected_inputfield.options)
          {
            let the_val = sub.theoptions.find((item)=>{return item.id ==option.id})
            if(the_val)
            {
               new_row.push("+")
            }
            else
            {
              new_row.push("")
            }
          }
        }
        //select


      //multiselect
        if(this.selected_inputfield.type=="multiselect")
        {
          for(let option of this.selected_inputfield.options)
          {
            let the_submission_text = sub.submission_text
            if(the_submission_text)
            {
              the_submission_text = JSON.parse(the_submission_text)
              if(the_submission_text.includes(option.id))
              {
                new_row.push("+")
              }
              else
              {
                new_row.push("")
              }
            }
            
            
          }
        }
        //multiselect

        
        sheet.push(new_row)
      }

      let ws =  XLSX.utils.json_to_sheet(sheet)
      let wb =  XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Tedarikçiler")
      XLSX.writeFile(wb,this.$store.state.brands.brand.name+" raporu.xls")


    },
    getCellOptionValue(sub_id,option_id)
    {
      if(this.selected_inputfield.type=="select" )
      {
       
        let sub = this.supplier_data.find((item)=>{return item.id == sub_id})
        
        let col_data = sub.theoptions.find((item)=>{return item.id == option_id})
        if(col_data)
        {
          return '<i class="pi pi-check-circle text-green-500"></i>' 
        }
        else
        {
          return '<i class="pi pi-times-circle text-red-500"></i>'
        }
      }

      if(this.selected_inputfield.type=="multiselect" )
      {
        
        let sub = this.supplier_data.find((item)=>{return item.id == sub_id})
        
        let submission_text = sub.submission_text
        if(submission_text)
        {
          submission_text = JSON.parse(submission_text)
          if(submission_text.includes(option_id))
          {
            return '<i class="pi pi-check-circle text-green-500"></i>'
          }
           else
          {
            return '<i class="pi pi-times-circle text-red-500"></i>'
          }

        }
       
      }
      return ""
    },

    getCellOptionTextValue(sub_id,option_id)
    {
      if(this.selected_inputfield.type=="listselect" )
      {
        //console.log(option_id)
        //console.log(sub_id)
        //console.log(this.selected_inputfield)
        let sub = this.supplier_data.find((item)=>{return item.id == sub_id})
        let col_data = this.selected_inputfield.options.find((item)=>{return item.id == option_id})
        if(col_data)
        {
          //console.log("col_data")
          //console.log(col_data)
          return '<i class="pi pi-check-circle text-green-500"></i>' 
        }
        else
        {
          //console.log(sub)
          return '<i class="pi pi-times-circle text-red-500"></i>'
        }
      }
      return ""
    },
    herewego(data,column)
    {
      console.log(data)
      console.log(column)
      let sub = this.supplier_data.find((item)=>{return item.id == data.id})
      
    },
    getCellListInputValue(sub,column_id)
    {
      
      //console.log(column_id)
      
      let the_column = this.selected_inputfield.columns.find(item=>item.id == column_id)
      //console.log(sub)
      if(sub && sub.theoption && sub.theoption.columns)
      {
        let col = sub.theoption.columns.find((item)=>{return item.id == column_id})
        if(col)
        {
          if(the_column.type=="select")
          {
            let the_option = the_column.options.find(item=>item.id == col.value)
            return the_option.name
          }
          else
          {
            return col.value
          }
          
        }
        else
        {
          return null
        }
      }
      return null
    },
    getCellColumnValue(sub_id,column_id)
    {
      if(this.selected_inputfield.type=="columns" || this.selected_inputfield.type=="text" || this.selected_inputfield.type=="longtext"|| this.selected_inputfield.type=="number")
      {
        let sub = this.supplier_data.find((item)=>{return item.id == sub_id})
        let col_data = sub.thecolumns.find((item)=>{return item.id == column_id})
        if(!col_data)
        {
          //console.log("none")
          //console.log(sub)
          //console.log(column_id)
          return "-"
        }
        else
        {
          return col_data.value
        }
        
        
      }
      return "-"
      
    },
  	async getData()
  	{
  		this.loading = true
  		this.projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
  		this.loading = false
  	},
    generateSupplierTable(submissions)
    {

    },
  	async getFlows()
  	{
      this.selected_flow_id = null
      this.selected_inputfield_id = null
      this.graph_ready = false
  		this.loading_flows = true      
      this.projectflows = await this.generalApiGetWithoutLoader("project_flows/"+this.selected_project_id)
      this.projectperiods = await this.generalApiGetWithoutLoader("projectperiods/"+this.selected_project_id)
      //console.log("projectperiods")
      //console.log(this.projectperiods)
  		this.loading_flows = false
  	},

  	async getInputfields()
  	{
      this.selected_inputfield_id = null
      this.graph_ready = false
  		this.loading_inputfield = true
  		this.selected_flow = this.projectflows.find((item)=>{return item.id == this.selected_flow_id})
  		if( this.selected_flow.type=="education")
  		{
  			this.querable_flow_selected = false
  			this.loading_inputfield = false
  			return false
  		}
  		else
  		{
  			let inputfields = await this.generalApiGetWithoutLoader("questionlists/inputfields_for_analysis/"+this.selected_flow.questionlist_id+"/"+this.selected_period_id)
        console.log(inputfields)

        for(let inputfield of inputfields)
        {
          if(inputfield.name.length>150)
          {
            inputfield.short_name = inputfield.name.slice(0, 150)+"...";
          }
          else
          {
            inputfield.short_name = inputfield.name
          }
          
        }
        this.inputfields = await inputfields
        //console.log(inputfields)

  			this.querable_flow_selected = true
  			this.loading_inputfield = false
  		}  		
  	},

    filterSubmissionByNullReason(submissions)
    {
      let final_submissions = []
      for(let submission of submissions)
      {
        if(submission.suppliers.id==2640)
        {
          console.log("submission")
          console.log(submission)
        }
        let duplicate_ind = final_submissions.findIndex((item)=> item.suppliers.id== submission.suppliers.id)
        if(duplicate_ind==-1)
        {
            if(!submission.is_nulled)
            {
              final_submissions.push(submission)
            }
            else
            {
              if(submission.nullreason && submission.nullreason.full_points_selected)
              {
                final_submissions.push(submission)
              }
            }

        }
        

      }
      return final_submissions

    },

  	async inputfieldSelected()
  	{
      this.graph_ready = false
      
  		this.selected_inputfield = this.inputfields.find((item)=>{return item.id == this.selected_inputfield_id})
  		//console.log(this.selected_inputfield)
      if(this.selected_flow.type=="audit")
      {
        let audit_options =  await this.generalApiGetWithoutLoader("questionlistoptions/"+this.selected_flow.questionlist_id)
        this.selected_inputfield.options = audit_options
      }
      console.log("OPTIONS")
      console.log(this.selected_inputfield);
  		let submissions = await this.generalApiGetWithoutLoader("questionlists/inputfieldsubmissions/"+this.selected_inputfield_id+"/"+this.selected_flow_id+"/"+this.selected_period_id)
  		console.log(submissions)
      submissions = this.filterSubmissionByNullReason(submissions)
      //this.supplier_data = submissions
      this.supplier_data = []
      let supplier_data = []
      if(this.selected_inputfield.type =="text" ||this.selected_inputfield.type =="longtext" )
      {
        let sorted_columns = []

        sorted_columns.push({name:this.selected_inputfield.name,id:this.selected_inputfield.id})
        this.selected_inputfield.sorted_columns = sorted_columns
        for(let submission of submissions)
        {
          
          submission.thecolumns= []

          let sub_column_obj = {
            name:this.selected_inputfield.name,
            id:this.selected_inputfield.id,
            value:submission.submission_text 
          }
          submission.thecolumns.push(sub_column_obj)

          supplier_data.push(submission)
        }
        
        this.graph_ready = await true
      }

  		//if select
  		if(this.selected_inputfield.type =="select")
  		{
  			let bardata = []
  			let labels = []
  			this.selected_inputfield.options = await this.selected_inputfield.options.map((item)=>{  
  				item.submission_count = 0
  				return item
  			})
  			for(let submission of submissions)
  			{
          submission.theoptions= []
  				let selected_option_ind = this.selected_inputfield.options.findIndex((item)=>{return item.id == submission.submission_option})
  				if(selected_option_ind !==-1)
  				{
  					this.selected_inputfield.options[selected_option_ind].submission_count++

            let sub_option_obj = {
              id:this.selected_inputfield.options[selected_option_ind].id,
              value:1 
            }
            submission.theoptions.push(sub_option_obj)

            supplier_data.push(submission)

  				}
          
          
  				//submissiondata
  			}
        let ind = 1
  			for(let option of this.selected_inputfield.options)
  			{
  				bardata.push(option.submission_count)
  				if(option.translations.length)
          {
            let translation = option.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
            labels.push(ind+". "+translation.translation.slice(0, 20))
          }
          else
          {
            labels.push(ind+". "+option.name.slice(0, 20))
          }
          ind++

          
  			}
  			this.graph_ready = await true
  			await setTimeout(()=>{
  				this.$refs.barchart.changeBarData(bardata,labels)
  			},100)
  			

  		}
  		//if select
      if(this.selected_inputfield.type =="listinput")
      {
        //this.selected_inputfield.columns
        let sorted_columns = []
        for(let column of this.selected_inputfield.columns)
        {          
          //console.log(column)
          sorted_columns.push({name:column.name,id:column.id})
        }
        this.selected_inputfield.sorted_columns = sorted_columns

        for(let submission of submissions)
        {
          let submission_text = JSON.parse(submission.submission_text)
          if(submission_text)
          {
            for(let submission_text_obj of submission_text)
            {
              let sub_to_add = this.sanitizeArray(submission)
              sub_to_add.theoption = submission_text_obj                  
              supplier_data.push(sub_to_add)
            }
          }
          
        }
        this.graph_ready = await true
      }
      //if multiselect
      if(this.selected_inputfield.type =="multiselect" || this.selected_inputfield.type =="listselect")
      {
        let bardata = []
        let labels = []
        this.selected_inputfield.options = await this.selected_inputfield.options.map((item)=>{  
          item.submission_count = 0
          return item
        })

        let sorted_options = []
        sorted_options.push({name:this.selected_inputfield.name,id:this.selected_inputfield.id})
        this.selected_inputfield.sorted_options = sorted_options

        for(let submission of submissions)
        {
          
          let submission_text = JSON.parse(submission.submission_text)
          
          if(submission_text)
          {
            console.log("submission_text")
            console.log(submission_text)
            let sub_to_add
              for(let submission_text_item of submission_text)
              {
                sub_to_add = this.sanitizeArray(submission)
                
                 let selected_option_ind = this.selected_inputfield.options.findIndex((item)=>{return item.id == submission_text_item})
                if(selected_option_ind !==-1)
                {
                  this.selected_inputfield.options[selected_option_ind].submission_count++
                  sub_to_add.theoption = this.selected_inputfield.options[selected_option_ind].name                  
                  
                }         
                if(this.selected_inputfield.type =="listselect")       
                {
                  supplier_data.push(sub_to_add)
                }                
              }
              if(this.selected_inputfield.type =="multiselect")       
              {
                supplier_data.push(sub_to_add)
              } 
              
          }
                  
        }


        let ind = 1
        for(let option of this.selected_inputfield.options)
        {
          bardata.push(option.submission_count)
          if(option.translations.length)
          {
            let translation = option.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
            labels.push(ind+". "+translation.translation.slice(0, 20))
          }
          else
          {
            labels.push(ind+". "+option.name.slice(0, 20))
          }
          
          ind++
        }
        this.graph_ready = await true
        await setTimeout(()=>{
          this.$refs.barchart.changeBarData(bardata,labels)
        },100)


      }
      //if multiselect
      //if boolean
      if(this.selected_inputfield.type =="boolean")
      {
        let linedata = []
        let labels = [this.$store.state.languages.lang_phrases.hayir,this.$store.state.languages.lang_phrases.evet]
        let true_count = 0
        let false_count = 0
        for(let submission of submissions)
        {
          if(submission.submission_option===1)
          {
            true_count++
          }
          if(submission.submission_option===0)
          {
            false_count++
          }
        }

        this.graph_ready = await true
        await setTimeout(()=>{
          this.$refs.piechart.changeBarData([false_count,true_count],labels)
        },100)


      }
      //if boolean

      //if number
      if(this.selected_inputfield.type =="number")
      {
        
        let labels = ["En Düşük Değer","Ortalama", "En Yüksek Değer"]
        let sub_val_arr = []

        for(let submission of submissions)
        {
          sub_val_arr.push(submission.submission_numerical)
        }
        let min = Math.min(...sub_val_arr)
        let avg = sub_val_arr.reduce((a, b) => a + b, 0) / sub_val_arr.length;
        let max = Math.max(...sub_val_arr)
        let column_data = [
          {name:this.$store.state.languages.lang_phrases.en_dusuk_deger,submission_average:min},
          {name:this.$store.state.languages.lang_phrases.en_yuksek_deger,submission_average:max},
          {name:this.$store.state.languages.lang_phrases.ortalama,submission_average:avg},
        ]
        this.selected_inputfield.sorted_columns = column_data
        this.selected_inputfield.tablecolumns = [this.selected_inputfield]

         for(let submission of submissions)
          {
            submission.thecolumns= []

            let sub_column_obj = {
              name:this.selected_inputfield.name,
              id:this.selected_inputfield.id,
              value:submission.submission_numerical 
            }
            submission.thecolumns.push(sub_column_obj)
            supplier_data.push(submission)
          }

        this.graph_ready = await true
        await setTimeout(()=>{
          this.$refs.linechart.changeBarData([min,avg,max],labels,this.$store.state.languages.lang_phrases.sutun_ortalamalari)
        },100)



      }

      //if number
      //if column
      if(this.selected_inputfield.type =="columns")
      {
        console.log("column type")
        console.log(this.selected_inputfield)
        this.selectedreadonlycolumns = []
        let linedata = []
        let labels = []
        let sorted_columns = []
        for(let column of this.selected_inputfield.columns)
        {
          if(column.type=="number")
          {
            //console.log("number")
            column.submission_amount = 0
            column.submission_average = 0
            sorted_columns.push(column)
          }
          if(column.type=="select")
          {            
            column.submission_amount = 0
            column.submission_average = 0
            sorted_columns.push(column)
          }

          if(column.type=="custom" && column.submit_to_db)
          {            
            column.submission_amount = 0
            column.submission_average = 0
            sorted_columns.push(column)
          }

          if(column.type=="readonly" && column.show_on_graphs)
          {
            //console.log("readonly")
            //selectedreadonlycolumns
            this.selectedreadonlycolumns.push(column)
            //console.log("selectedreadonlycolumns")
            //console.log(this.selectedreadonlycolumns)
            

          } 
        }
        this.selected_inputfield.sorted_columns = sorted_columns
        for(let submission of submissions)
        {
          let submission_text = JSON.parse(submission.submission_text)
          if(submission_text)
          {
             submission.thecolumns= []
              for(let submission_text_item of submission_text)
              {
                 let selected_column_ind = this.selected_inputfield.sorted_columns.findIndex((item)=>{return item.id == submission_text_item.id})
                if(selected_column_ind !==-1)
                {

                  let sub_column_obj = {
                      name:this.selected_inputfield.sorted_columns[selected_column_ind].name,
                      id:this.selected_inputfield.sorted_columns[selected_column_ind].id,
                      value:0
                    }
                  let submission_text_item_value = 0
                  if(submission_text_item.value || submission_text_item.value===0)
                  {
                    if(this.selected_inputfield.sorted_columns[selected_column_ind].type=="select")
                    {
                      let the_option = this.selected_inputfield.sorted_columns[selected_column_ind].options.find(item=>item.id == submission_text_item.value)
                      if(the_option)
                      {
                        sub_column_obj.value = the_option.points
                        submission_text_item_value = the_option.points 
                      }
                    }
                    else if(this.selected_inputfield.sorted_columns[selected_column_ind].type=="custom" && this.selected_inputfield.sorted_columns[selected_column_ind].submit_to_db)
                    {
                      sub_column_obj.value = submission_text_item.value
                      submission_text_item_value = submission_text_item.value
                    }
                    else
                    { 
                      sub_column_obj.value = submission_text_item.value
                      submission_text_item_value = submission_text_item.value 
                    }

                    this.selected_inputfield.sorted_columns[selected_column_ind].submission_amount += parseFloat(submission_text_item_value)
                    this.selected_inputfield.sorted_columns[selected_column_ind].submission_average = parseFloat((this.selected_inputfield.sorted_columns[selected_column_ind].submission_amount/submissions.length).toFixed(3))
                     
                    submission.thecolumns.push(sub_column_obj)
                                       
                  }
                  else
                  {
                    let sub_column_obj = {
                      id:this.selected_inputfield.sorted_columns[selected_column_ind].id,
                      name:this.selected_inputfield.sorted_columns[selected_column_ind].name,
                      value:"-"
                    }
                    submission.thecolumns.push(sub_column_obj)
                  }
                  
                }
              } 
              supplier_data.push(submission)
          }
                  
        }

        let ind = 1
        
        for(let column of this.selected_inputfield.sorted_columns)
        {          
          linedata.push(column.submission_average)
          if(column.translations.length)
          {
            let translation = column.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
            labels.push(ind+". "+translation.translation.slice(0, 20))
          }
          else
          {
            labels.push(ind+". "+column.name.slice(0, 20))
          }
          
          ind++
        }
        this.graph_ready = await true
        await setTimeout(()=>{
          this.$refs.linechart.changeBarData(linedata,labels,this.$store.state.languages.lang_phrases.sutun_ortalamalari)
        },100)



      }
      //if column  		
      //console.log("supplier_data")
      //console.log(supplier_data)
      this.supplier_data = supplier_data
  	},

    generateList(data,columns)
    {
      if(data.suppliers)
      {
        let supplier_name = data.suppliers.name

        
        let name_obj =  {
            type:"text",
            field:"name",
            header:"tedarikci",
            hide_on_mobile:false,
          }
          this.suppliers_columns.push(name_obj)
        //loop
        for(let column of columns)
        {
          let column_obj =  {
            type:"text",
            field:"brand_name",
            header:"marka",
            hide_on_mobile:false,
          }
        }
        //loop
      }
      
    },
  },
}
</script>

<style lang="css" scoped>
</style>